import React from 'react'
import cx from 'classnames'
import { Message } from 'intl'

import { Icon } from 'components/dataDisplay'
import { ButtonBase } from 'components/inputs'
import type { ButtonBaseProps } from 'components/inputs'

import s from './ActionButton.scss'


export const styles = [ 'gold-50', 'gold-30', 'black' ] as const

type ActionButtonStyle = typeof styles[number]

export type ActionButtonProps = ButtonBaseProps & AtLeastOne<{
  children: React.ReactElement
  title?: Intl.Message | string
}> & {
  style?: ActionButtonStyle
  wordBreak?: boolean
}

const ActionButton: React.FunctionComponent<ActionButtonProps> = (props) => {
  const {
    children, className, title, loading, disabled, style = 'gold-50', wordBreak = false,
    ...rest
  } = props

  const titleClassName = cx(s.title, !wordBreak && 'whitespace-nowrap')
  const buttonClassName = cx(className, s.button, s[`style-${style}`], {
    [s.disabled]: disabled,
  })

  const buttonBaseProps = {
    className: buttonClassName,
    loading,
    disabled,
    ...rest,
  }

  return (
    <ButtonBase className={s.button} {...buttonBaseProps}>
      <span className={s.container}>
        <span className={titleClassName}>
          {
            title ? (
              <Message value={title} />
            ) : (
              children
            )
          }
        </span>
        <Icon className={s.icon} name="other/long-arrow-right" />
      </span>
    </ButtonBase>
  )
}


export default ActionButton
